import script from "./customField.vue?vue&type=script&setup=true&lang=js"
export * from "./customField.vue?vue&type=script&setup=true&lang=js"

import "./customField.vue?vue&type=style&index=0&id=8dc2bb3a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dc2bb3a"]])

export default __exports__